export const c = (...classNames: unknown[]) => {
  return classNames.filter((className) => className).join(' ')
}
